/**
 * Språkene appen kan vises på: norsk, pluss én per ordbok som er bygget med
 * `npm run i18n`. Lista er kjent på byggetidspunktet, så begge velgerne -
 * den under Innstillinger og knappen på sidene før innlogging - kan vise den
 * uten å hente noe først.
 */
import { dictionaries } from './i18n'

/** Kildespråket appen er skrevet på har ingen ordbok - teksten står i koden. */
export const NORWEGIAN = { code: 'nb', name: 'Norsk' }

export const languageList = [
  NORWEGIAN,
  ...Object.entries(dictionaries)
    .map(([code, dict]) => ({ code, name: dict.name }))
    .sort((a, b) => a.name.localeCompare(b.name, 'nb')),
]

/**
 * Navnet på et språk. En familie kan ha lagret et språk det ikke lenger
 * finnes ordbok for - da er koden det ærligste vi har å vise.
 */
export function languageName(code) {
  const wanted = code || NORWEGIAN.code
  return languageList.find((l) => l.code === wanted)?.name ?? wanted
}
